import { Button, Flex } from '@chakra-ui/react';
import { getAddButtonLabel } from 'app/components/Audio';

export interface AudioSelectActionsProps {
  checkedItemsCount?: number;
  pluralCountSuffix?: string;
  singularCountSuffix?: string;
  onCancel: () => void;
  disabled?: boolean;
  onClick: () => void;
}

export const AudioSelectActions = ({
  checkedItemsCount,
  pluralCountSuffix,
  singularCountSuffix,
  onCancel,
  disabled,
  onClick,
}: AudioSelectActionsProps) => {
  const addButtonLabel = getAddButtonLabel({
    singularCountSuffix,
    checkedItemsCount,
    pluralCountSuffix,
  });

  return (
    <Flex justify="flex-end" p={4}>
      <Button variant="secondary" size="md" onClick={onCancel}>
        Cancel
      </Button>
      <Button
        ml={4}
        onClick={onClick}
        size="md"
        isDisabled={disabled || checkedItemsCount === 0}
        data-testid="audio-selection-add-button"
      >
        {addButtonLabel}
      </Button>
    </Flex>
  );
};
